import { REDUX_MODEL_KEY } from '../../../../redux/constants/key'
import getClassNameReduxUtil from '../../../../redux/utils/get-class-name'
import isInstanceReduxUtil from '../../../../redux/utils/is-instance'
import isPointerReduxUtil from '../../../../redux/utils/is-pointer'
import addReferenceReduxUtil from '../../../../redux/actions/create/add-reference'
import createInstanceAddReduxUtil from '../../../../redux/actions/create/create-instance'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'

export default function createPointerAddReduxUtil (stateWrapper, payload) {
  const {
    existingInstance,
    referencePath,
    association,
    properties,
    isLocal
  } = payload

  if (isPointerReduxUtil(association)) {
    return association
  }

  // Create the pointer
  let instance
  if (isInstanceReduxUtil(association)) {
    instance = association
  } else {
    instance = createInstanceAddReduxUtil(stateWrapper, {
      data: {
        [REDUX_MODEL_KEY.CHANGED]: association,
        className: getClassNameReduxUtil(association),
        ...properties
      },
      isLocal,
      existingInstance
    })
  }

  const pointer = createPointerReduxUtil(instance)
  stateWrapper.state = addReferenceReduxUtil({
    instance,
    referencePath,
    stateWrapper
  })
  return pointer
}
